import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import paperBackground from './assets/background.JPG';
import './styles/App.css';

function App() {
  return (
    <div
      className="App"
      style={{ '--paper-bg': `url(${paperBackground})` }}
    >
      <Header />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
